import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Photo from "components/shared/stays/Photo";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
import { Keyboard, Pagination } from "swiper";
import styles from "components/destination/GallerySmall.module.scss";

export default function GallerySmall({ photos }) {
  const [paginationEl, setPaginationEl] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    // update swiper pagination element once available
    if (paginationEl && swiperInstance) {
      swiperInstance.params.pagination.el = paginationEl;
      swiperInstance.pagination.init();
      swiperInstance.pagination.render();
      swiperInstance.pagination.update();
    }
  }, [swiperInstance, paginationEl]);

  return (
    <div className={styles.component}>
      <Swiper
        modules={[Keyboard, Pagination]}
        speed={200}
        cssMode
        keyboard={{
          enabled: true,
        }}
        pagination={{
          el: paginationEl,
          type: "fraction",
        }}
        onBeforeInit={(swiper) => {
          setSwiperInstance(swiper);
        }}
      >
        {photos.map((photo, index) => (
          <SwiperSlide key={photo.id}>
            <div className={styles.slide}>
              <Photo
                src={photo.file.url}
                alt={photo.tripName}
                layout="fill"
                objectFit="cover"
                priority={index === 0}
              />
            </div>
          </SwiperSlide>
        ))}
        <div className={styles.pagination}>
          <div ref={(node) => setPaginationEl(node)} />
        </div>
      </Swiper>
    </div>
  );
}

GallerySmall.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      created_at: PropTypes.string,
      position: PropTypes.number,
      tripName: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        content_type: PropTypes.string,
        byte_size: PropTypes.number,
        width: PropTypes.number,
      }),
    })
  ).isRequired,
};
